import { ConversationRatedEntry } from 'lib-shared-legacy-types';

import { getRatingTypeText } from 'components/conversation/components/messages/SatisfactionRatingReceivedMessages/getRatingTypeText';
import type { Score } from 'fable/ScoreIcon';

import { CsatRatingMessage } from '../../../conversation/components/messages/SatisfactionRatingReceivedMessages/csatRatingMessage';
import { NpsRatingMessage } from '../../../conversation/components/messages/SatisfactionRatingReceivedMessages/npsRatingMessage';
import { ThumbsUpOrDownRatingMessage } from '../../../conversation/components/messages/SatisfactionRatingReceivedMessages/thumbsUpOrDownRatingMessage';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import styles from './logEntry/logEntry.module.scss';
import { UserLink } from './userLink/userLink';

type ConversationRatedProps = {
  entry: ConversationRatedEntry;
};

export const ConversationRated = ({
  entry,
}: ConversationRatedProps): JSX.Element => {
  const authorName = getLogEntryAuthorName(entry);
  const authorLink = <UserLink userId={entry.author.id}>{authorName}</UserLink>;

  const agentName = getLogEntryAuthorName({
    ...entry,
    author: entry.agent,
  });

  const agentLink = entry.agent ? (
    <UserLink userId={entry.agent.id}>{agentName}</UserLink>
  ) : undefined;

  const text = (
    <>
      Conversation is rated ({getRatingTypeText(entry.rating_type)}) by customer{' '}
      {authorLink}
      {agentLink && <> for agent {agentLink}</>}
    </>
  );

  const renderRatingMessage = () => {
    if (entry.rating_score === undefined) {
      return 'Score not available';
    }

    const ratingType = entry.rating_type;

    switch (ratingType) {
      case 'Nps':
        return (
          <NpsRatingMessage
            score={entry.rating_score}
            comment={entry.rating_message || ''}
          />
        );
      case 'ThumbsUpOrDown':
        return (
          <ThumbsUpOrDownRatingMessage
            score={entry.rating_score}
            comment={entry.rating_message || ''}
          />
        );
      case 'Csat':
        return (
          <CsatRatingMessage
            ratingStyle="numbers"
            score={entry.rating_score as Score}
            comment={entry.rating_message || ''}
          />
        );
    }
  };

  return (
    <LogEntry entry={entry} text={text}>
      <div className={styles.message}>{renderRatingMessage()}</div>
    </LogEntry>
  );
};
